import { ApolloCache, ApolloError, BaseMutationOptions, DefaultContext, OperationVariables, gql, useMutation } from '@apollo/client';
import { GET_PATIENT_BY_ID } from '../../queries';
import { IOkPayload } from '../../types/mutations/generics';

interface ISetIsHealthCoachingEnabledInput {
  athenaId: string;
  status: string;
}

interface ISetIsHealthCoachingEnabledOutput {
  setHealthCoachingStatus: IOkPayload;
}

const SET_HEALTHCOACH_STATUS = gql`
  mutation setHealthCoachingStatus($athenaId: String!, $status: String) {
    setHealthCoachingStatus(athenaId: $athenaId, status: $status) {
      ok
    }
  }
`;

interface IUseSetIsHealthCoachingEnabled {
  athenaId: string;
  onError?: ((error: ApolloError, clientOptions?: BaseMutationOptions<any, OperationVariables, DefaultContext, ApolloCache<any>> | undefined) => void) | undefined;
  onCompleted?:
    | ((data: ISetIsHealthCoachingEnabledOutput, clientOptions?: BaseMutationOptions<ISetIsHealthCoachingEnabledInput, OperationVariables, DefaultContext, ApolloCache<any>> | undefined) => void)
    | undefined;
}

export const useSetHealthCoachStatus = ({ athenaId, onError, onCompleted }: IUseSetIsHealthCoachingEnabled) => {
  const [mutate, { data, loading }] = useMutation<ISetIsHealthCoachingEnabledOutput, ISetIsHealthCoachingEnabledInput>(SET_HEALTHCOACH_STATUS, {
    refetchQueries: [
      {
        query: GET_PATIENT_BY_ID,
        variables: {
          id: athenaId,
        },
      },
    ],
    awaitRefetchQueries: true,
    onError: onError,
    onCompleted: onCompleted,
  });

  return {
    mutate,
    data,
    loading,
  };
};
